// custom component (not registry-generated)
import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

export { default as Card } from './Card.vue'
export { default as CardAction } from './CardAction.vue'
export { default as CardContent } from './CardContent.vue'
export { default as CardDescription } from './CardDescription.vue'
export { default as CardFooter } from './CardFooter.vue'
export { default as CardHeader } from './CardHeader.vue'
export { default as CardTitle } from './CardTitle.vue'

// Brand pass (workshop D7): the signature flat card — borderless, no shadow,
// the named 24px module token (`rounded-card`, never the radius knob).
//
// The `variant` axis frames two surfaces that used to be standalone promote
// families, folded in at the 2026-07-22 audit consolidation:
//   • `media` — an image-background frame (no padding): drop an `<img
//     class="absolute inset-0 size-full object-cover">`, an optional gradient
//     scrim (`from-foreground/80`, tokens — the toolkit bans blur on modules),
//     and bottom-aligned content. Absorbs KUICoreCardBackground /
//     KUILearnExploreCardContainer / KUICoreOverlayPanel.
//   • `spotlight` — a glow frame: drop a `<Spotlight>` blob + `relative z-10`
//     content. Absorbs KUIUnifiedSpotlightCard (blur = size ÷ 5, one per layout).
// `default` is the flat D7 card composed from the parts (CardHeader/Content/…).
//
// The `shape` axis controls the card's aspect / fill, orthogonal to `variant`:
//   • `auto` — natural, content-driven height (default).
//   • `square` — 1:1 tile (`aspect-square`); the toolkit spotlight-tile shape.
//   • `stretch` — fills the parent's height (`h-full`), so cards in a grid row
//     line up (the KUIUnifiedSpotlightCard `h-full` behaviour).
// Forked from the registry card to carry these axes (drops out of drift tracking).
export const cardVariants = cva(
  'text-card-foreground',
  {
    variants: {
      variant: {
        default: 'flex flex-col gap-6 rounded-card bg-card py-6',
        media: 'relative block overflow-hidden rounded-card bg-muted',
        spotlight: 'relative overflow-hidden rounded-card bg-card p-6 lg:p-8',
      },
      shape: {
        auto: '',
        square: 'aspect-square',
        stretch: 'h-full',
      },
    },
    defaultVariants: {
      variant: 'default',
      shape: 'auto',
    },
  },
)
export type CardVariants = VariantProps<typeof cardVariants>
